import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonTeam = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 34.5985 35.25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M17.2992 8C15.434 8 13.9242 6.49025 13.9242 4.625C13.9242 2.75975 15.434 1.25 17.2992 1.25C19.1645 1.25 20.6742 2.75975 20.6742 4.625C20.6742 6.49025 19.1645 8 17.2992 8Z",
				stroke: "var(--stroke-0, #F55200)",
				strokeWidth: 2.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M27.4242 8C26.1808 8 25.1742 6.9935 25.1742 5.75C25.1742 4.5065 26.1808 3.5 27.4242 3.5C28.6677 3.5 29.6742 4.5065 29.6742 5.75C29.6742 6.9935 28.6677 8 27.4242 8Z",
				stroke: "var(--stroke-0, #FFF58C)",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M7.17424 8C8.41773 8 9.42424 6.9935 9.42424 5.75C9.42424 4.5065 8.41773 3.5 7.17424 3.5C5.93074 3.5 4.92424 4.5065 4.92424 5.75C4.92424 6.9935 5.93074 8 7.17424 8Z",
				stroke: "var(--stroke-0, #9600FF)",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M20.7813 32.8712C20.7201 33.3729 20.2941 33.75 19.7887 33.75H14.8092C14.3039 33.75 13.8779 33.373 13.8166 32.8713L12.7504 24.1475C12.7104 23.8204 12.5119 23.5341 12.2197 23.3819L10.6257 22.5517C10.2438 22.3529 10.0321 21.932 10.1001 21.5069L11.0975 15.2719C11.2581 14.2693 11.9183 13.4325 12.8364 13.0879C13.8368 12.7125 15.7268 12.375 17.2997 12.375C18.0828 12.375 20.066 12.4594 21.7132 13.0697C22.6461 13.4156 23.3373 14.2552 23.4993 15.2719L24.4966 21.5069C24.5646 21.932 24.3529 22.3529 23.9711 22.5517L22.3772 23.3818C22.0849 23.534 21.8864 23.8205 21.8465 24.1476L20.7813 32.8712Z",
				stroke: "var(--stroke-0, #FFA8BB)",
				strokeWidth: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M28.5492 11.375C29.0973 11.375 30.0554 11.4467 31.2084 11.9655C31.8615 12.2595 32.3453 12.9732 32.4587 13.8374L33.0839 19.0356C33.1772 19.8108 32.8161 20.5706 32.1562 20.9879C31.6436 21.3121 31.3034 21.849 31.2292 22.4509L30.5809 27.7086C30.3844 29.3026 29.0303 30.5 27.4242 30.5",
				stroke: "var(--stroke-0, #FFF58C)",
				strokeWidth: 3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_6",
				d: "M6.04919 11.375C5.50106 11.375 4.54301 11.4467 3.39005 11.9655C2.73702 12.2595 2.25315 12.9732 2.13975 13.8374L1.51456 19.0356C1.42132 19.8108 1.78233 20.5706 2.44228 20.9879C2.95484 21.3121 3.29505 21.849 3.36926 22.4509L4.01752 27.7086C4.21406 29.3026 5.56812 30.5 7.17419 30.5",
				stroke: "var(--stroke-0, #9600FF)",
				strokeWidth: 3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgPersonTeam);
export { ForwardRef as ReactComponent };
